var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4042 17.7615L13.1365 14.476C9.65787 17.2316 4.59811 16.7017 1.75199 13.2041C-1.09413 9.70656 -0.356245 4.51323 3.12234 1.75758C6.60093 -0.998063 11.6607 -0.468131 14.4014 3.02942C16.7205 5.99704 16.7205 10.2365 14.4014 13.2041L17.6692 16.4897C18.0908 16.8077 18.0908 17.3376 17.7746 17.7615C17.4583 18.0795 16.9313 18.0795 16.4042 17.7615C16.5096 17.7615 16.5096 17.7615 16.4042 17.7615ZM1.8574 8.11677C1.8574 11.6143 4.70352 14.37 8.0767 14.37C9.65788 14.37 11.2391 13.734 12.3986 12.5682L12.504 12.4622C14.9285 9.91854 14.8231 5.99704 12.3986 3.55935C9.97411 1.12166 6.07387 1.12166 3.6494 3.66534C2.48987 4.83119 1.8574 6.42099 1.8574 8.11677Z",
    fill: "#57689F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.284f31cf0f76178734a199b3a994e07b.svg";
export { ForwardRef as ReactComponent };